import { cn } from '@evolve/common-ui';
import { Menu } from '@headlessui/react';
import React, { ReactNode } from 'react';

interface OptionsMenuItemWithBadgeProps {
  label: string;
  badge?: number;
  icon?: ReactNode;
  onClick: () => void;
  itemStyles?: string;
}
export function OptionsMenuItemWithBadge({
  label,
  badge = 0,
  onClick,
  icon,
  itemStyles,
}: OptionsMenuItemWithBadgeProps) {
  return (
    <Menu.Item>
      <div
        onClick={onClick}
        key={`label--${label}`}
        className={cn(
          'options-menu-item-button flex justify-between',
          itemStyles
        )}
      >
        <span>{label} </span>
        {badge > 0 && (
          <span className="text-xs bg-red-500 text-white rounded-full py-0.5 px-2">
            {badge}
          </span>
        )}
        {icon && <span className="text-xs px-2">{icon}</span>}
      </div>
    </Menu.Item>
  );
}
